import { createSlice } from '@reduxjs/toolkit'

import { langDefault, getLangIndexByCode, normalizeLangIndex } from '../utils/language';

export const langIndexSlice = createSlice({
  name: 'langIndex',
  initialState: {
    value: getLangIndexByCode(langDefault),
  },
  reducers: {
    changeLangIndex: (state, action) => {
      state.value = normalizeLangIndex(action.payload)
    },
  },
})

export const { changeLangIndex } = langIndexSlice.actions

export const getLangIndex = (state) => {
  return state.langIndex.value
}

export default langIndexSlice.reducer
